import { memo, type FC } from 'react';

import { getRouteApi } from '@mint/routing';

import {
  BUILDER_ROW_TYPES,
  EMPTY_VALUE,
} from '../../../../../../constants/campaignBuilder.js';
import { BuilderTableRow } from '../../../../types.js';
import FormattedField from '../FormattedField/FormattedField.jsx';

export type Props = {
  value: number | null | string;
  row: BuilderTableRow;
  cellColor: string;
};

const routeApi = getRouteApi(
  '/_secured/campaign/$campaignId/planning/buying-plan',
);

const OrderIdField: FC<Props> = memo(({ value, row, cellColor }) => {
  const { campaignId } = routeApi.useParams();
  const { type, scale, selectedPlanId, ioVersionIndex } = row.original;
  const isTileRow = type === BUILDER_ROW_TYPES.TILE;
  const isEmptyValue = !value || !ioVersionIndex;

  const displayValue = isEmptyValue
    ? EMPTY_VALUE
    : `${value}.${ioVersionIndex}`;

  if (!isTileRow) {
    return null;
  }

  if (isEmptyValue) {
    return (
      <FormattedField
        scale={scale}
        value={displayValue}
        color={cellColor}
        variant="text"
      />
    );
  }

  return (
    <FormattedField
      scale={scale}
      value={displayValue}
      color="text.link"
      variant="link"
      linkProps={{
        to: '/campaign/$campaignId/planning/insertion-orders/',
        params: { campaignId },
        search: { id: Number(value), mediaplan: selectedPlanId ?? undefined },
      }}
    />
  );
});
export default OrderIdField;
